import { SectionResponseDto } from '@diritto/common/home/dtos/section.dtos';
import { Http } from '@diritto/common/utils/requester/http';
import { AxiosRequestConfig } from 'axios';

export class SectionApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async getSection(slug: string, options?: AxiosRequestConfig) {
    const res = await this.http.get<SectionResponseDto>(`${this.url}/home/sections/${slug}`, options);
    return res.data;
  }
}
